<mat-spinner [diameter]="30" *ngIf="isLoading; else boxContent" class="spinner"></mat-spinner>

<ng-template #boxContent>

    <figure *ngIf="!isLoading" [class]="viewMode">
        <div class="axis-y">
            <div class="macrocycle"><span>{{ 'MacroCycles' | translate }}</span></div>
            <div class="phases"><span>{{ 'Phases' | translate }}</span></div>
            <div class="percents">
                <ul>
                    <li>100 %</li>
                    <li>90 %</li>
                    <li>80 %</li>
                    <li>70 %</li>
                    <li>60 %</li>
                    <li>50 %</li>
                    <li>40 %</li>
                    <li>30 %</li>
                    <li>20 %</li>
                    <li>10 %</li>
                </ul>
            </div>
            <div class="accents">{{ 'Accents' | translate }}</div>
            <div class="weeks">{{ 'Week' | translate }}</div>
        </div>

      <div class="graph-inner" (scroll)="onScroll($event)" horizontalScrollDirective #scrollable>
        <div class="graph" [style.width]="chartWidth + 'px'">

          <div class="selector">
            <ul>
              <li *ngFor="let week of weeks" (click)="onWeekClicked(week)" [class.active]="clickedSelector == week.id" matRipple>
                  <span class="macro-cycle">
                  </span>
                  <span class="phase">
                  </span>
              </li>
            </ul>
          </div>

          <div class="legend-top">
            <div class="macrocycles">
              <ul>
                <li *ngFor="let annualMacroCycle of annualPlanMacroCycles"
                    [style.left]="((annualMacroCycle.annualPlanMacroCycleWeekFrom??1) * 30) - 30 + 'px'"
                    [style.width]="(((annualMacroCycle.annualPlanMacroCycleWeekTo??0) - (annualMacroCycle.annualPlanMacroCycleWeekFrom??0)) + 1) * 30 +'px'"
                    [style.background]="annualMacroCycle.macroCycleHexadecimalColor">
                  <span *ngIf="annualMacroCycle.macroCycleTranslationName">
                    {{ annualMacroCycle.macroCycleTranslationName }}
                  </span>
                </li>
              </ul>
            </div>
            <div class="phases">
              <ul>
                <li *ngFor="let annualPlanPhase of annualPlanPhases" [style.left]="((annualPlanPhase.annualPlanPhaseWeekFrom??1) * 30) - 30 + 'px'" [style.width]="(((annualPlanPhase.annualPlanPhaseWeekTo??0) - (annualPlanPhase.annualPlanPhaseWeekFrom??0)) + 1) * 30 +'px'">
                  <span *ngIf="annualPlanPhase.phaseHexadecimalColor" [style.background]="annualPlanPhase.phaseHexadecimalColor"></span>
                </li>

                <!--
                <li *ngFor="let data of annualPlanPhases" [ngStyle]="{'width': (data.weekTo - data.weekFrom) * 30 + 'px', 'background': data.phase.hexadecimalColor}"></li>
                -->
              </ul>
            </div>
          </div>
          <div class="chart">
            <div class="no-data" *ngIf="!hasData()">
                {{ 'message.no_data' | translate }}
            </div>
              <div class="horizontal-lines">
                  <ul>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                  </ul>
              </div>
            <div class="chart-lines">
              <svg [attr.viewBox]="chartViewBox">
                <defs>
                    <linearGradient id="grad2" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" style="stop-color:rgb(110,110,110);stop-opacity:0.4" />
                        <stop offset="100%" style="stop-color:rgb(216,216,216);stop-opacity:0.4" />
                    </linearGradient>
                </defs>
                  <polygon
                      fill="url(#grad2)"
                      stroke="#787878"
                      stroke-width="0"
                      [attr.points]="chartSvgPoints"
                  />
              </svg>
            </div>
            <div class="col" *ngFor="let week of weeks">
              <div class="bar">
                <span class="block sport {{item.value['name']}}" *ngFor="let item of week.accents | keyvalue"
                      [style.height]="item.value['percent'] + '%'"
                      [style.background]="item.value['color']">
                  <span class="bar-value" [class.active]="clickedSelector == week.id">{{ item.value['percent'] }}</span>
                </span>

                  <!--
                <span class="block sport" [ngStyle]="{'height': week.sportPercent + '%'}"><span class="bar-value" [class]="{'active': clickedSelector == week.id}">{{ week.sportPercent }}</span></span>
                <span class="block physical" [ngStyle]="{'height': week.physicalPercent + '%'}"><span class="bar-value" [class]="{'active': clickedSelector == week.id}">{{ week.physicalPercent }}</span></span>
                -->
              </div>
            </div>
              <div class="chart-lines-above">
                  <svg [attr.viewBox]="chartViewBox">
                      <defs>
                          <linearGradient id="grad2" x1="0%" y1="0%" x2="0%" y2="100%">
                              <stop offset="0%" style="stop-color:rgb(110,110,110);stop-opacity:0.4" />
                              <stop offset="100%" style="stop-color:rgb(216,216,216);stop-opacity:0.4" />
                          </linearGradient>
                      </defs>
                      <polygon
                          fill="none"
                          stroke="#787878"
                          stroke-width="2"
                          [attr.points]="chartSvgPoints"
                      />

                  </svg>
              </div>
          </div>

          <div class="legend">
            <div class="weeks">
              <div class="week-accents">
                <ul>
                  <li *ngFor="let week of weeks" class="week">
                    <ul class="accents">
                        <!--
                      <li *ngFor="let category of week.exerciseCategories" [ngStyle]="{'width': 100 / week.exerciseCategories.length + '%', 'background': category.colorHex}"><span></span></li>
                      -->
                    </ul>
                  </li>
                </ul>
              </div>

              <div class="week-number">
                <ul>
                  <li *ngFor="let week of weeks">
                    <span>{{ week.realWeekNumber || week.weekNumber }}</span>
                    <div class="has-event" *ngIf="week?.comment"></div>
                  </li>
                </ul>
              </div>
              <div class="week-name" *ngIf="showMonths">
                <ul>
                  <li *ngFor="let data of dayInMonths" [style.width]="data.width + '%'"><span>{{ data.month|appDate:'MMM yyyy':'':currentLang }}</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </figure>
</ng-template>
